import { useRef } from "react";
import { Prompt } from "../components/Audio";
import { CheckIcon } from "../components/Icons";
import InkPad, { savedStrokesOf } from "../components/InkPad";
import ui from "../components/ui.module.css";

export { pageIn } from "../components/InkPad";

// Draw or trace on the shared ink surface. Done with nothing drawn is fine and
// saves no picture.
//
// Tracing is never scored: the response records only that it was done and how
// many lines remain.
const DrawingStep = ({
  step,
  saved,
  onDone,
  onProgress,
  onUnavailable,
  saving,
  tracing = false,
}) => {
  const pad = useRef(null);

  const done = async () => {
    if (!pad.current?.ready) return;
    const { strokes } = pad.current;
    const response = tracing
      ? { completed: true, stroke_count: strokes.length }
      : { completed: true };
    // Nothing drawn: done straight away, with no picture.
    if (!strokes.length) {
      onDone(response, null);
      return;
    }
    onDone(response, await pad.current.exportPng());
  };

  return (
    <>
      <Prompt step={step} />
      <InkPad
        ref={pad}
        template={step.template}
        saved={savedStrokesOf(saved?.work)}
        tracing={tracing}
        disabled={saving}
        onUnavailable={onUnavailable}
        onChange={(strokes) =>
          onProgress?.({
            completed: false,
            work: { format: "strokes-v1", strokes },
          })
        }
        actions={(ready) => (
          <button
            type="button"
            className={`${ui.button} ${ui.large} ${ui.primary}`}
            onClick={done}
            disabled={!ready || saving}
          >
            <CheckIcon size={24} />
            {saving ? "Saving…" : "Done"}
          </button>
        )}
      />
    </>
  );
};

export default DrawingStep;
